import { render, staticRenderFns } from "./Lineaetica.vue?vue&type=template&id=58610735&"
import script from "./Lineaetica.vue?vue&type=script&lang=js&"
export * from "./Lineaetica.vue?vue&type=script&lang=js&"
import style0 from "./Lineaetica.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports